import { useCloseWebView } from '../hooks/useCloseWebView.js';
import { runningInApp } from '../appConstants/appConstants.js';

var useGlobalLogout = function () {
    var closeWebView = useCloseWebView().closeWebView;
    var globalLogout = function () {
        if (runningInApp) {
            closeWebView();
            sessionStorage.clear();
        }
        else {
            window.location.href = "".concat(window.location.origin, "/login");
        }
    };
    return { globalLogout: globalLogout };
};

export { useGlobalLogout };
